angular.module("myZoneMainModule",[

])
    .controller("myZoneMainCtrl",['$scope',function($scope){

    }
    ]);